// Tela 6 — matriz de Derivas Conversacionais (Eixo P). Conversão verbatim de
// design-references/brief-3/shared/cards-3.jsx L1237-1266: markup/classes
// idênticos (derivas-matrix, derivas-matrix__diag, derivas-matrix__cell) +
// intensity rgba(217,119,6,${min(1,v/24)*0.4}). window.X → import; F.* → props VM.
import type { DerivasRowVM } from '../../view-models';
import type React from 'react';

const COLS = ['Suporte', 'Cobrança', 'Vendas', 'Reclamação', 'Retenção'];

export function DerivasMatrix({ transitions }: { transitions: DerivasRowVM[] }): React.JSX.Element {
  return (
    <table className="derivas-matrix">
      <thead>
        <tr>
          <th />
          {COLS.map((c) => (
            <th key={c}>{c}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {transitions.map((row) => (
          <tr key={row.from}>
            <th>{row.from}</th>
            {COLS.map((c) => {
              const v = row.to[c];
              if (v === '-')
                return (
                  <td key={c} className="derivas-matrix__diag">
                    —
                  </td>
                );
              const intensity = typeof v === 'number' ? Math.min(1, v / 24) : 0;
              return (
                <td
                  key={c}
                  className="derivas-matrix__cell"
                  style={{ background: `rgba(217, 119, 6, ${(intensity * 0.4).toString()})` }}
                >
                  {v}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
